/**
 * @name agentsRequests
 * @description Function used to make request to the tour endpoints
 * @param requestor
 * @returns {object} agentsRequests
 */
export const agentsRequests = (requestor: any) => ({
  /**
   * @name activateDeactivateAgent
   * @description Function used to make request to activate or deactivate an agent
   * @param {string} agentId
   * @param {string} action
   * @returns {Promise<any>} response
   */
  activateDeactivateAgent: async (agentId: string, action: string) => {
    const data = { agentId };
    const url = action === 'activate' ? `/users/activateAgent` : `/users/deactivateAgent`;
    const response = await requestor({
      method: 'POST',
      url,
      data,
    });
    return response;
  },
  /**
   * @name get - handle all get requests for estimate
   */
  get: {
    /**
     * @name getAgents
     * @description Function used to get all posts
     * @param {string} type
     * @returns {object} response
     */
    getAgents: async () => {
      const url = `/users/getAllAgents`;
      const response = await requestor({
        method: 'GET',
        url,
      });

      return response;
    },
  },
  /**
   * @name deleteAgent
   * @description Function used to delete an agent
   * @param {string} agentId
   * @returns {Promise<any>} response
   */
  deleteAgent: async (agentId: string) => {
    const response = await requestor({
      method: 'DELETE',
      url: `/users/deleteAgent/${agentId}`,
    });
    return response;
  },
  updateAgent: async (agentId: string, data: any) => {
    const response = await requestor({
      method: 'PATCH',
      url: `/users/updateAgent/${agentId}`,
      data,
    });
    return response;
  },

  getAllStaffUsers: async () => requestor({ method: 'GET', url: '/users/getAllStaffUsers' }),

  activateDeactivateStaffUser: async (userId: string, action: 'activate' | 'deactivate') => {
    const url = action === 'activate' ? '/users/activateStaffUser' : '/users/deactivateStaffUser';
    return requestor({ method: 'POST', url, data: { userId } });
  },

  deleteStaffUser: async (userId: string) =>
    requestor({ method: 'DELETE', url: `/users/deleteStaffUser/${userId}` }),

  updateStaffRole: async (userId: string, role: string) =>
    requestor({ method: 'PATCH', url: `/users/updateStaffRole/${userId}`, data: { role } }),

  inviteStaffUser: async (data: { email: string; username: string; role: string }) =>
    requestor({ method: 'POST', url: '/users/inviteStaff', data }),

  resendStaffInvitation: async (userId: string) =>
    requestor({ method: 'POST', url: `/users/resendInvitation/${userId}` }),

  editStaffUser: async (userId: string, data: { username?: string; email?: string; role?: string }) =>
    requestor({ method: 'PATCH', url: `/users/editStaffUser/${userId}`, data }),
});

